import React,{useState,useEffect} from "react"
import { refreshNotifications } from "../utils/notifications";
import { connect } from "react-redux"
import PropTypes from "prop-types"
import {
  Grid,
} from "@mui/material"
import { withRouter } from "../utils/router";
import EnhancedTable from "./enhancedTable"
import {
  deletePersonalContact,
  getPersonalPhonebook,
} from "../utils/utils"
import {
  setNotifications,
  setNotificationsLoading,
} from "../store/features/notification/notificationSlice"
import { setCalls } from "../store/features/calls/callSlice"
import { setVoicemails } from "../store/features/voicemails/voicemailSlice"
import { setSmsConversations } from "../store/features/smsConversations/smsConversationsSlice"
import { setFaxes } from "../store/features/faxes/faxSlice"
import { setRecordings } from "../store/features/recordings/recordingSlice"
import { setError } from "../store/features/error/errorSlice"
import { setPersonalPhonebook } from "../store/features/phonebook/personalPhonebookSlice"
import ContactEmail from "./contactEmail"
import { resetSession } from "../store/features/session/sessionSlice"
import ContactInfoInternal from "./contactInfoInternal"
import ContactInfoExternal from "./contactInfoExternal"
import ContactInfoPersonal from "./contactInfoPersonal"

const mapDispatchToProps = {
  setError,
  setCalls,
  setVoicemails,
  setSmsConversations,
  setFaxes,
  setRecordings,
  setNotifications,
  setNotificationsLoading,
  setPersonalPhonebook,
  resetSession,
};

const headCells = () => {
  return {
    all: [
      { id: "name", numeric: false, disablePadding: false, label: "Name", },
      { id: "phone", numeric: true, disablePadding: false, label: "Phone" },
      { id: "email", numeric: true, disablePadding: false, label: "Email" },
      { id: "actions", numeric: true, disablePadding: false, label: "Actions" },
    ],
    internal: [
      { id: "name", numeric: false, disablePadding: false, label: "Name", },
      { id: "phone", numeric: true, disablePadding: false, label: "Phone" },
      { id: "email", numeric: true, disablePadding: false, label: "Email" },
      { id: "actions", numeric: true, disablePadding: false, label: "Actions" },
    ],
    external: [
      { id: "name", numeric: false, disablePadding: false, label: "Name", },
      { id: "phone", numeric: true, disablePadding: false, label: "Phone" },
      { id: "email", numeric: true, disablePadding: false, label: "Email" },
      { id: "actions", numeric: true, disablePadding: false, label: "Actions" },
    ],
    personal: [
      { id: "name", numeric: false, disablePadding: false, label: "Name", },
      { id: "phone", numeric: true, disablePadding: false, label: "Phone" },
      { id: "email", numeric: true, disablePadding: false, label: "Email" },
      { id: "actions", numeric: true, disablePadding: false, label: "Actions" },
    ],
  }
}

const Contacts = (props) => {
  const {
    title,
    menu,
    menuItems,
    history,
    phonebook,
    externalPhonebook,
    personalPhonebook,
    session,
    resetSession,
    setVoicemails,
    setSmsConversations,
    setFaxes,
    setRecordings,
    setNotifications,
    setNotificationsLoading,
    setCalling,
    notifications,
    setValue,
    match,
    setPersonalPhonebook,
    setError,
    landingPage,
  } = props;

  let contactsTab = match.params.tab;
  const [page,setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [icInfoOpen, setIcInfoOpen] = useState(false)
  const [ecInfoOpen, setEcInfoOpen] = useState(false)
  const [pcInfoOpen, setPcInfoOpen] = useState(false)
  const [pcInfoEdit, setPcInfoEdit] = useState(false)
  const [contactItem, setContactItem] = useState(null)
  const [createPersonalContact, setCreatePersonalContact] = useState(false);
  const [email, setEmail] = useState(false);
  const [recipient, setRecipient] = useState('');
  const [filterTerm, setFilterTerm] = useState('');
  const defaultValues = {
    server: session.lastServer,
    token: session.token,
  };

  // Calls a number of a contact from its info card, the way the Call action
  // of the list does: the Calls view opens with the number being dialled.
  const callFromCard = (contact, number) => {
    const numberToCall = String(number || "").trim();
    if (numberToCall === "") return;
    setIcInfoOpen(false);
    setEcInfoOpen(false);
    setCalling(true);
    // An internal extension is resolved to the colleague by the Calls view.
    // Any other number is handed over with the contact's name, so the dialer
    // shows who is called and not "Unknown User".
    const isExtension = contact.type === "internal" &&
      numberToCall === String(contact.voicemail?.mailbox || "").trim();
    setValue(isExtension ? numberToCall : {
      pid: 0,
      firstName: contact.firstName || numberToCall,
      lastName: contact.firstName ? (contact.lastName || "") : "",
      email: contact.email || "",
      preferredDeviceNumbers: { office: numberToCall, mobile: "", custom: "" },
      voicemail: { mailbox: numberToCall },
    });
    history.push(`/dashboard/${landingPage}`);
  };

  const emailFromCard = (address) => {
    setIcInfoOpen(false);
    setEcInfoOpen(false);
    setRecipient(address);
    setEmail(true);
  };

  const createPersonalContactCb = () => {
    setCreatePersonalContact(true)
    setPcInfoOpen(true)
  }

  const setOpenContactInfo = (type) => {
    if (type === "internal") {
      setIcInfoOpen(true)
    } else if (type === "external") {
      setEcInfoOpen(true)
    }
    else if (type === "personal") {
      setPcInfoOpen(true)
    }
  }

  const searchContacts = (value) => {
    setFilterTerm(value.toLowerCase())
  }

  // Search helpers. They tolerate contacts with missing fields, and numbers
  // match on their digits so that typing a number the way it is displayed,
  // "+1 (561) 877", finds a contact stored as "5618775080".
  const searching = filterTerm.length >= 2;
  const termDigits = /^[\d\s()+.-]+$/.test(filterTerm) ? filterTerm.replace(/\D/g, "") : "";
  const matchesText = (value) => String(value || "").toLowerCase().includes(filterTerm);
  const matchesNumber = (value) => {
    const text = String(value || "");
    if (text === "") return false;
    if (text.toLowerCase().includes(filterTerm)) return true;
    if (termDigits.length < 2) return false;
    const digits = text.replace(/\D/g, "");
    return digits.includes(termDigits) ||
      (termDigits.length > 2 && termDigits[0] === "1" && digits.includes(termDigits.slice(1)));
  };

  const phonebookFiltered = phonebook.filter((item) =>
    !searching ||
    matchesText(item.firstName) ||
    matchesText(item.lastName) ||
    matchesText(item.email) ||
    matchesNumber(item.voicemail?.mailbox) ||
    matchesNumber(item.numbers?.office) ||
    matchesNumber(item.numbers?.mobile) ||
    matchesNumber(item.incomingProviderNumber?.number) ||
    matchesNumber(item.fax?.number) ||
    matchesNumber(item.conversation?.number)
  )

  const externalPhonebookFiltered = externalPhonebook.filter((item) =>
    !searching ||
    matchesText(item.firstName) ||
    matchesText(item.lastName) ||
    matchesNumber(item.numbers?.office) ||
    matchesNumber(item.numbers?.mobile) ||
    matchesNumber(item.numbers?.fax) ||
    matchesNumber(item.numbers?.sms) ||
    matchesNumber(item.speedDial?.code) ||
    matchesNumber(item.speedDial?.number)
  )

  const personalPhonebookFiltered = personalPhonebook.filter((item) =>
    !searching ||
    matchesText(item.firstName) ||
    matchesText(item.lastName) ||
    matchesText(item.email) ||
    matchesNumber(item.numbers?.office) ||
    matchesNumber(item.numbers?.mobile) ||
    matchesNumber(item.numbers?.fax) ||
    matchesNumber(item.numbers?.sms)
  )

  const createRowDataInternal = (item) => {
    let obj = {
      name: item.firstName + ' ' + item.lastName,
      phone: item.voicemail.mailbox,
      email: item.email,
      actions: [
        { type: "contactInfo" },
        { type: "contactCall" },
        { type: "contactEmail" },
      ],
      object: {
        type: "internal",
        ...item
      },
    };

    return obj;
  }

  const createRowDataExternal = (item) => {
    let obj = {
      name: item.firstName + ' ' + item.lastName,
      // The speed dial number is the one shown for external contacts; fall
      // back to the business number so the column is not left empty.
      phone: item.speedDial?.number || item.numbers?.office || item.number || '',
      email: '',
      actions: [
        { type: "contactInfo" },
        { type: "contactCall" },
        { type: "contactEmail" },
      ],
      object: {
        type: "external",
        ...item
      },
    };

    return obj; 
  }

  const createRowDataPersonal = (item) => {
    let obj = {
      name: item.firstName + ' ' + item.lastName,
      phone: item.numbers.office,
      email: item.email,
      actions: [
        // { type: "contactInfo" },
        { type: "contactCall" },
        { type: "contactEmail" },
        { type: "contactEdit" },
        { type: "contactDelete" },
      ],
      object: {
        type: "personal",
        ...item
      },
    };

    return obj; 
  }

  const generateRows = ()=>{
    switch (contactsTab) {
      case "all":
        return [
          ...personalPhonebookFiltered
            .map((item) => {
              return createRowDataPersonal(item);
            }),
          ...phonebookFiltered
            .map((item) => {
              return createRowDataInternal(item);
            }),
          ...externalPhonebookFiltered
            .map((item) => {
              return createRowDataExternal(item);
            })
        ];
      case "internal":
        return phonebookFiltered
          .map((item) => {
            return createRowDataInternal(item);
          });
      case "external":
        return externalPhonebookFiltered
          .map((item) => {
            return createRowDataExternal(item);
          });
      case "personal":
        return personalPhonebookFiltered
          .map((item) => {
            return createRowDataPersonal(item);
          });
      default:
        break;
    }
  }

  const refetchNotifications = () => refreshNotifications({
    values: defaultValues,
    setters: { setCalls, setFaxes, setRecordings, setVoicemails, setSmsConversations },
    setNotifications,
    setNotificationsLoading,
    onUnauthorized: () => {
      resetSession();
      history.push('/login');
    },
  });

  const clearCurrentNotifications = () =>{
    // let values = defaultValues;

    try {
      // updateVoicemails(values);
      refetchNotifications();
    } catch (error) {
      console.error(error);
    }
  }

  useEffect(() => {
    clearCurrentNotifications();
    // eslint-disable-next-line
  }, [contactsTab, title]);

  const handleDeleteForever = async (item) => {
    let values = defaultValues;
    values.id = item.pid

    try {
      await deletePersonalContact(values);
      try {
        await getPersonalPhonebook(
            {
                token: session.token,
                server: session.lastServer,
            },
            setPersonalPhonebook
        );
        setError({
          visible: true,
          type: "success",
          message: "Successfully deleted Item",
        });
    } catch (error) {
        setError({
            visible: true,
            type: "error",
            message: "Failed to refetch contacts. " + error,
        })
    }
    } catch (error) {
        setError({
          visible: true,
          type: "error",
          message: "Failed to delete contact. " + error,
      })
      console.error(error);
    }
  }

  return (
    <Grid container>
      <Grid size={12}>
        <ContactEmail
          open={email}
          setOpen={setEmail}
          to={recipient}
        />
        <ContactInfoInternal
          open={icInfoOpen}
          setOpen={setIcInfoOpen}
          contact={contactItem}
          onCall={callFromCard}
          onEmail={emailFromCard}
        />
        <ContactInfoExternal
          open={ecInfoOpen}
          setOpen={setEcInfoOpen}
          contact={contactItem}
          onCall={callFromCard}
          onEmail={emailFromCard}
        />
        <ContactInfoPersonal
          open={pcInfoOpen}
          setOpen={setPcInfoOpen}
          edit={pcInfoEdit}
          setEdit={setPcInfoEdit}
          create={createPersonalContact}
          setCreate={setCreatePersonalContact}
          contact={contactItem}
          setContact={setContactItem}
        />
        <EnhancedTable
          setError={setError}
          type="contact"
          headerData={headCells()}
          rowData={generateRows()}
          dense={false}
          hasActions={true}
          selectable={false}
          menu={menu ? menuItems : false}
          searchFunc={searchContacts}
          title={title}
          tab={contactsTab}
          history={history}
          hasClear={false}
          setPage={setPage}
          setRowsPerPage={setRowsPerPage}
          rowsPerPage={rowsPerPage}
          page={page}
          handleDialClick={null}
          setCalling={setCalling}
          setValue={setValue}
          setOpenContactInfo={setOpenContactInfo}
          setEditContactInfo={setPcInfoEdit}
          setContact={setContactItem}
          loading={notifications.loading}
          handleDeleteForever={handleDeleteForever}
          setRecipient={setRecipient}
          setSendEmail={setEmail}
          useGroupFilter={false}
          createItemCallback={contactsTab === "personal" ? createPersonalContactCb : null}
          createItemTooltip={"Create Personal Contact"}
          refreshDataOnSameTab={clearCurrentNotifications}
        />
      </Grid>
    </Grid>
  );
};

Contacts.propTypes = {
  title: PropTypes.string.isRequired,
  menu: PropTypes.bool.isRequired,
  menuItems: PropTypes.arrayOf(
    PropTypes.shape({
      title: PropTypes.string,
      linkId: PropTypes.string,
    })
  ),
  tab: PropTypes.string.isRequired,
  handleDialClick: PropTypes.func.isRequired,
  setCalling: PropTypes.func.isRequired,
  setValue: PropTypes.func.isRequired,
};

const mapStateToProps = (state) => {
  return {
    session: state.session,
    phonebook: state.phonebook,
    externalPhonebook: state.externalPhonebook,
    personalPhonebook: state.personalPhonebook,
    notifications: state.notifications,
    landingPage: state.user.landingPage,
  };
};

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(Contacts)
);